import FormSwitch from './FormSwitch';

export default FormSwitch;
